module.exports = __webpack_public_path__ + "static/media/gym-todo.edf15671.svg";